import '../styles/NavigationPages.scss';
import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState } from 'react';
import ajax from '@/scripts/ajax';
import { List } from 'antd';
//页面身份
export default function NavigationPages() {
    const [data, setState] = useState([]);
    useEffect(() => {
        ajax.get('query/list')
            .then((response) => {
                let data = [];
                for (let i in response) {
                    // console.log(i, response[i]);
                    data.push({ key: i, value: response[i] });
                }
                setState(data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    return (
        <div className="list">
            <PageHeader title="导航黄页" sticky></PageHeader>
            <List
                itemLayout="horizontal"
                dataSource={data}
                renderItem={(item, index) => (
                    <List.Item>
                        <List.Item.Meta title={<span>{item.key}</span>} description={<a href={item.value}>{item.value}</a>} />
                    </List.Item>
                )}
            />
        </div>
    );
}
